module.exports = "/resources/assets/prod/6f330ecd92541669cf8f5b9e88ee19db.jpg";